/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Plan_Credit_Pack_RemainingInputs */

const cs_billing_plan_credit_pack_remaining = /** @type {(inputs: Billing_Plan_Credit_Pack_RemainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zbývající kredity (pool)`)
};

const en_billing_plan_credit_pack_remaining = /** @type {(inputs: Billing_Plan_Credit_Pack_RemainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits remaining (pool)`)
};

/**
* | output |
* | --- |
* | "Credits remaining (pool)" |
*
* @param {Billing_Plan_Credit_Pack_RemainingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_plan_credit_pack_remaining = /** @type {((inputs?: Billing_Plan_Credit_Pack_RemainingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Plan_Credit_Pack_RemainingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_plan_credit_pack_remaining(inputs)
	return cs_billing_plan_credit_pack_remaining(inputs)
});